// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/build/css/" + chunkId + "." + "a1b14fb0f77ab3c9ed82" + ".css";
};